import React from 'react';
import * as d3 from 'd3';
import { useCanvas } from '../../components/Canvas';
import { TrackLine } from '../../components/TrackLine';
import { Timeline } from './Timeline';
import { palette } from '../../../constants';
import { sortSeriesByName } from '../../utils/sortByName';
export function TimelineGroup(_a) {
    var series = _a.series, activeSet = _a.activeSet, hovered = _a.hovered, accessors = _a.accessors, xDomain = _a.xDomain, barHeight = _a.barHeight, colorScheme = _a.colorScheme, _b = _a.verticalSpacing, verticalSpacing = _b === void 0 ? 16 : _b, className = _a.className;
    var _c = useCanvas(), boundedWidth = _c.boundedWidth, boundedHeight = _c.boundedHeight;
    var xScale = React.useMemo(function () { return d3.scaleTime().domain(xDomain).range([0, boundedWidth]); }, [boundedWidth, xDomain]);
    var timeSeries = React.useMemo(function () { return sortSeriesByName(Object.values(series), accessors).reverse(); }, [series]);
    return (React.createElement("g", { className: (className !== null && className !== void 0 ? className : '') + " Chart--Timelines" },
        React.createElement("rect", { width: boundedWidth, height: boundedHeight, x: 0, y: 0, fill: "none" }),
        React.createElement("g", { transform: "translate(0, " + verticalSpacing / 2 + ")" }, timeSeries.map(function (s, i) {
            var key = accessors.key(s);
            if (!activeSet.has(key))
                return null;
            return (React.createElement("g", { key: key, transform: "translate(0, " + (i * -barHeight - verticalSpacing) + ")", opacity: 1 },
                React.createElement(Timeline, { series: s, accessors: accessors, xScale: xScale, fillColor: hovered === undefined || hovered === key
                        ? colorScheme(key)
                        : palette.neutral4 })));
        })),
        React.createElement(TrackLine, null)));
}
//# sourceMappingURL=TimelineGroup.js.map